
















import VideoHero from "~/themes/fiskarsMoominDefault/components/components/organisms/VideoHero/VideoHero.vue";
import {computed} from "@nuxtjs/composition-api";

export default {
  name: "MoominVideoHero",
  components: { VideoHero },
  props: {
    title: {
      type: String
    },
    subTitle: {
      type: String
    },
    buttonText: {
      type: String
    },
    buttonUrl: {
      type: String
    },
    videoUrl: {
      type: String,
    },
    mobileVideoUrl: {
      type: String,
    },
    themeType: {
      type: Object
    },
    videoPoster: {
      type: Object
    },
    mobileVideoPoster: {
      type: Object
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    mute: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const _themeType = computed(() => props.themeType?.selectedValues || []);
    const _selectedThemeType = computed(() => _themeType?.value[0]?.key === 'theme2' ? 'light' : 'dark');

    return {
      _selectedThemeType
    }
  }
}
